import React from 'react'
import styled from '@emotion/styled'
import { hexColors } from '@mobi/settings'
import { Icon, type IconProps } from '@mobi/component-library/Common/Icon'
import * as iconPaths from '@mobi/component-library/Common/Icon/iconPaths'

interface TippingPoolHeaderProps {
  description: string
  icon: keyof typeof iconPaths
}

export function TippingPoolHeader({ description, icon }: TippingPoolHeaderProps): JSX.Element {
  return (
    <HeaderStyled>
      <IconStyled type={icon === 'FB' ? 'FBL' : icon || 'tab'} />
      {description}
    </HeaderStyled>
  )
}

// Styles

const IconStyled = styled(Icon)<IconProps>({
  margin: '0 1rem 0 0',
  zIndex: 1,
  position: 'relative',
})

const HeaderStyled = styled.h3({
  color: hexColors.white,
  backgroundColor: hexColors.black,
  margin: '1rem 0',
  display: 'flex',
  alignItems: 'center',
})
